import type { ReactNode } from "react"

export type InteractionStateTone = "loading" | "empty" | "error" | "denied"

export const InteractionState = ({
  tone,
  title,
  detail,
  action,
}: {
  tone: InteractionStateTone
  title: string
  detail: string
  action?: ReactNode
}) => (
  <section className={`interaction-state interaction-state-${tone}`} aria-live="polite">
    <span className="interaction-state-mark" aria-hidden="true">
      {tone === "loading" ? <span className="spinner" /> : tone === "empty" ? "—" : "!"}
    </span>
    <div>
      <h2>{title}</h2>
      <p>{detail}</p>
      {action}
    </div>
  </section>
)
